<tr class="table-row table-header-row" [class.mod-panel]="panel">
  <!-- Selection -->
  <td *ngIf="!hideSelection" class="table-column table-header-column mod-checkbox" [class.mod-panel]="panel">
    <cp-checkbox [handleClick]="true" [cpModel]="isAllSelected" (checkboxClick)="toggleAll.emit()"></cp-checkbox>
  </td>

  <!-- Actions -->
  <td *ngIf="!hideActions && inlineActions?.length > 0"
       class="table-column table-header-column mod-actions"
       [ngClass]="actionClass">
    <span class="table-header-text">{{'Common.ops' | translate}}</span>
  </td>

  <!-- Headers -->
  <td *ngFor="let column of columns" class="table-column table-header-column"
       [class.mod-sortable]="column.sortable" [class.mod-panel]="panel" [ngClass]="getColumnClass(column)"
       (click)="sort.emit(column)">
    <div class="table-header-cell">
      <span class="table-header-text">{{column.header | translate}}</span>
      <span *ngIf="column.sortable" class="table-header-sort" [ngClass]="getSortIcon(column)"></span>
    </div>
  </td>
</tr>
